module.exports = __webpack_public_path__ + "assets/img/dongfu_qrcode.6c84c45a.png";